/**
 * Tag intent helpers for score / match / timing labels.
 * Status domain mapping lives in StatusPill/statusPill.utils — do not duplicate here.
 */

import type { TagIntent } from "@/components/ui/atoms/Tag";

/**
 * Test / fit scores.
 * >= 60 success, >= 40 warning, else error; null → secondary.
 */
export const getScoreIntent = (score?: number | null): TagIntent => {
  if (score == null) return "secondary";
  if (score >= 60) return "success";
  if (score >= 40) return "warning";
  return "error";
};

/**
 * CV match scores (0–1 or already scaled by caller).
 * >= 80 success, >= 60 warning, else error; null → secondary.
 */
export const getMatchScoreIntent = (score?: number | null): TagIntent => {
  if (score == null) return "secondary";
  if (score >= 80) return "success";
  if (score >= 60) return "warning";
  return "error";
};

/**
 * Question time spent.
 * Always info when a value exists (spent is capped to allocated in display);
 * secondary when missing.
 */
export const getQuestionTimeSpentIntent = (
  timeSpentSeconds: number | null | undefined,
  timeAllocatedMinutes?: number | null | undefined
): TagIntent => {
  void timeAllocatedMinutes;
  if (timeSpentSeconds == null) return "secondary";
  return "info";
};
